<script lang="ts">
import { CreateElement, VNode } from 'vue';
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import Icon from './icon.vue';
import Tick from './tick.vue';
import Security from './security.vue';
import Camera from './camera.vue';
import Reload from './reload.vue';
import Verification from './verification.vue';
import WechatPay from './wechatPay.vue';

const svgMap = {
  tick: Tick,
  security: Security,
  camera: Camera,
  reload: Reload,
  verification: Verification,
  wechatPay: WechatPay,
};

@Component
export default class FitIcon extends Vue {
  /** icon名称 */
  @Prop({ default: 'info' }) icon!: string;
  /** icon前缀，对应bkicon中的“图标前缀” */
  @Prop() prefix!: string;
  /** icon库名称，对应bkicon中的“Font family” */
  @Prop() namespace!: string;
  /** 填充（废弃） */
  @Prop() fill!: string;
  /** 大小（废弃） */
  @Prop() size!: string | number;
  render(createElement: CreateElement): VNode {
    // @ts-ignore
    if (svgMap[this.icon]) {
      // @ts-ignore
      return createElement(svgMap[this.icon], {
        props: {
          fill: this.fill,
          size: this.size,
        },
        class: {
          [`fit-icon-${this.icon}`]: true,
        },
      });
    }
    return createElement(Icon, {
      props: {
        icon: this.icon,
        namespace: this.namespace,
        prefix: this.prefix,
      },
    });
  }
};
</script>
